import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "./Dashboard";
import { Th, Td } from "./Customers";
import { useAuth } from "@/contexts/AuthContext";

export default function Ledger() {
  const { tenant } = useAuth();
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/sales/ledger").then(({ data }) => setRows(data)); }, []);

  return (
    <div className="p-4 sm:p-6 lg:p-12 max-w-[1400px]" data-testid="ledger-page">
      <PageHeader title="AR Ledger" subtitle="Every invoice posts a positive entry; every payment posts a negative entry. Filtered to current tenant." />
      <div className="mt-8 border border-[#0A0A0A] bg-white overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-[#0A0A0A] text-white text-[11px] uppercase tracking-[0.15em]">
            <tr><Th>Date</Th><Th>Type</Th><Th>Description</Th><Th align="right">Amount</Th></tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={r.id} data-testid={`ledger-row-${i}`} className="border-b border-[#DEE2E6] hover:bg-[#F8F9FA]">
                <Td className="text-[#495057]">{new Date(r.created_at).toLocaleString()}</Td>
                <Td><span className={`text-[10px] uppercase tracking-[0.15em] px-2 py-0.5 border ${r.entry_type === "invoice" ? "border-[#F5B700] bg-[#F5B700]/10 text-[#0A0A0A]" : "border-[#0B7A75] bg-[#0B7A75]/10 text-[#0B7A75]"}`}>{r.entry_type}</span></Td>
                <Td>{r.description}</Td>
                <Td align="right" className={`tabular-nums font-semibold ${r.amount >= 0 ? "text-[#D90429]" : "text-[#0B7A75]"}`}>
                  {r.amount >= 0 ? "+" : ""}{tenant?.currency || ""} {r.amount.toLocaleString()}
                </Td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={4} className="p-8 text-center text-[#495057]">No ledger entries yet — create an invoice to see one.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
